import { render } from "./CitizenID.vue?vue&type=template&id=3713508a"
import script from "./CitizenID.vue?vue&type=script&lang=js"
export * from "./CitizenID.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__